import { Injectable, Inject } from '@angular/core';
import { Login } from '../../interface/login/login';
import { User } from '../../model/user-login';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../../../shared/service/http/http-client.service';
import { IHeader } from '../../../shared/interface/iheader';
import { HttpObject } from '../../../shared/enum/http-object.enum';
import { HttpHeaderKey } from '../../../shared/enum/http-header-key.enum';

@Injectable()
export class LoginService  {
  serviceHttp : HttpClientService;
  constructor(sHttp : HttpClientService) { 
    this.serviceHttp = sHttp;
  }
  
  getLogin(data : User):Observable<Login>{
      let HeaderData : IHeader[] = [];
      HeaderData.push({key : HttpHeaderKey.CONTENTTYPE.toString(), value : HttpObject.URLENCODE.toString()})
      this.serviceHttp.setPath("token");
      this.serviceHttp.setHeader(HeaderData);
      return this.serviceHttp.getDataWithUrlEncode('username='+encodeURIComponent(data.email) + '&password='+ encodeURIComponent(data.password) + '&grant_type='+encodeURIComponent(HttpObject.GRANTTYPE.toString())) ;      
   }
   

}



// WEBPACK FOOTER //
// ./src/app/component/service/login/login.service.ts